module.exports = __webpack_public_path__ + "static/media/comment-icon.f3aafd48.svg";